export const reasonTypes = [
  { id: 1, name: "Motivo de baja", value: 1 },
  { id: 2, name: "Motivo de alta", value: 2 },
];
